import React from "react";
import {employeeService} from "../jwt/_services/hr/employeeService";

export const employeeProvider = {
    getOptions,
    getItem,
    getEmployesByDepartment,
    findAllMyDepartmentSupervisor
};

async function getOptions(){
    try {
        const listItems = await employeeService.getAll();
        return listItems.map((itemData) => {
            const { id, name, lastName, number } = itemData
            return (
                {
                    id: id,
                    value: number + " - " + name + " " + lastName,
                    label: <div><label>{number + " - " + name + " " + lastName}</label></div>}
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getEmployesByDepartment(department){
    try {
        const listItems = await employeeService.getEmployesByDepartment(department);
        return listItems.map((itemData) => {
            const { id, name, lastName, number } = itemData
            return (
                {
                    id: id,
                    value: number + " - " + name + " " + lastName,
                    label: <div><label>{number + " - " + name + " " + lastName}</label></div>}
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await employeeService.getItem(id);
        return (
            {
                id: item.id,
                value: item.number + " - " + item.name + " " + item.lastName,
                label: <div><label>{ item.number + " - " + item.name+ " " + item.lastName}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}

async function findAllMyDepartmentSupervisor(){
    try {
        const listItems = await employeeService.findAllMyDepartmentSupervisor();
        return listItems.map((itemData) => {
            const { id, name} = itemData
            return (
                {
                    id: id,
                    value: name ,
                    label: <div><label>{name}</label></div>}
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}
